import { render } from "./App.vue?vue&type=template&id=7aecde21&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7aecde21&lang=css"

import exportComponent from "/home/runner/work/ch-widget/ch-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__